const initialCategoriesSettingsState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  deleting: false,
  deleted: false,
  items: [],
  superCategories: {
    items: null,
    fetching: false,
    fetched: false,
    error: null
  },
  analysisPlan: {
    items: null,
    fetching: false,
    fetched: false,
    error: null
  },
  valuations: {
    items: null,
    fetching: false,
    fetched: false,
    error: null,
    coefficient: 0.0
  },
  error: null
};
export const categoriesSettingsReducer = (
  state = initialCategoriesSettingsState,
  action
) => {
  switch (action.type) {
    case "INIT_CATEGORIES_SETTINGS": {
      return initialCategoriesSettingsState;
    }
    case "SET_CATEGORIES_SETTINGS": {
      return {
        ...state,
        items: action.items
      };
    }
    case "SET_CREATED_CATEGORIES": {
      return {
        ...state,
        items: action.items
      };
    }
    case "SET_SUPER_CATEGORY_SETTINGS": {
      return {
        ...state,
        superCategories: {
          ...state.superCategories,
          items: action.items
        }
      };
    }
    case "SET_ANALYSIS_PLAN_SETTINGS": {
      return {
        ...state,
        analysisPlan: {
          ...state.analysisPlan,
          items: action.items
        }
      };
    }
    case "SET_VALUATION_SETTINGS": {
      return {
        ...state,
        valuations: {
          ...state.valuations,
          items: action.items
        }
      };
    }
    case "SET_LABELS_FORM": {
      return {
        ...state,
        labelsForm: action.labelsForm
      };
    }
    case "FETCH_CATEGORIES_SETTINGS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_CATEGORIES_SETTINGS_FULFILLED": {
      const data = action.payload.data.data;
      let items = [...state.items];
      // eslint-disable-next-line array-callback-return
      data.map(item => {
        items.push(item);
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }

    case "FETCH_CATEGORIES_SETTINGS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "FETCH_SUPER_CATEGORIE_LIST_PENDING": {
      let superCategories = {
        ...state.superCategories,
        fetched: false,
        fetching: true
      };
      return { ...state, superCategories };
    }
    case "FETCH_SUPER_CATEGORIE_LIST_FULFILLED": {
      const superCategories = {
        ...state.superCategories,
        items: action.payload.data.data,
        fetched: true,
        fetching: false
      };
      return {
        ...state,
        superCategories
      };
    }
    case "FETCH_SUPER_CATEGORIE_LIST_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        superCategories: { error }
      };
    }
    case "FETCH_ANALYSES_PLAN_LIST_PENDING": {
      let analysisPlan = {
        ...state.analysisPlan,
        fetched: false,
        fetching: true
      };
      return { ...state, analysisPlan };
    }
    case "FETCH_ANALYSES_PLAN_LIST_FULFILLED": {
      const analysisPlan = {
        ...state.analysisPlan,
        items: action.payload.data.data,
        fetched: true,
        fetching: false
      };
      return {
        ...state,
        analysisPlan
      };
    }
    case "FETCH_ANALYSES_PLAN_LIST_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        analysisPlan: { error }
      };
    }
    case "FETCH_VALUATION_LIST_PENDING": {
      let valuations = {
        ...state.valuations,
        fetched: false,
        fetching: true
      };
      return { ...state, valuations };
    }
    case "FETCH_VALUATION_LIST_FULFILLED": {
      const valuations = {
        ...state.valuations,
        items: action.payload.data.data,
        fetched: true,
        fetching: false
      };
      return {
        ...state,
        valuations
      };
    }
    case "FETCH_VALUATION_LIST_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        valuations: { error }
      };
    }
    case `UPDATE_CATEGORIES_SETTINGS_STATE_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `UPDATE_CATEGORIES_SETTINGS_STATE_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `UPDATE_CATEGORIES_SETTINGS_STATE_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }

    case `SAVE_CATEGORY_SETTINGS_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_CATEGORY_SETTINGS_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_CATEGORY_SETTINGS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }

    case `SAVE_SUPER_CATEGORY_SETTINGS_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_SUPER_CATEGORY_SETTINGS_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_SUPER_CATEGORY_SETTINGS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }
    case `SAVE_ANALYSIS_PLAN_SETTINGS_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_ANALYSIS_PLAN_SETTINGS_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_ANALYSIS_PLAN_SETTINGS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }
    case `SAVE_VALUATION_SETTINGS_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_VALUATION_SETTINGS_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_VALUATION_SETTINGS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }

    case `UPDATE_CATEGORY_SETTINGS_PENDING`: {
      return { ...state };
    }
    case `UPDATE_CATEGORY_SETTINGS_FULFILLED`: {
      return { ...state };
    }
    case `UPDATE_CATEGORY_SETTINGS_REJECTED`: {
      return { ...state };
    }
    case `UPDATE_SUPER_CATEGORY_SETTINGS_PENDING`: {
      return { ...state };
    }
    case `UPDATE_SUPER_CATEGORY_SETTINGS_FULFILLED`: {
      return { ...state };
    }
    case `UPDATE_SUPER_CATEGORY_SETTINGS_REJECTED`: {
      return { ...state };
    }
    case `UPDATE_ANALYSIS_PLAN_SETTINGS_PENDING`: {
      return { ...state };
    }
    case `UPDATE_ANALYSIS_PLAN_SETTINGS_FULFILLED`: {
      return { ...state };
    }
    case `UPDATE_ANALYSIS_PLAN_SETTINGS_REJECTED`: {
      return { ...state };
    }
    case `UPDATE_VALUATION_SETTINGS_PENDING`: {
      return { ...state };
    }
    case `UPDATE_VALUATION_SETTINGS_FULFILLED`: {
      return { ...state };
    }
    case `UPDATE_VALUATION_SETTINGS_REJECTED`: {
      return { ...state };
    }

    case `DELETE_CATEGORY_SETTINGS_PENDING`: {
      return { ...state, deleted: false, deleting: true };
    }
    case `DELETE_CATEGORY_SETTINGS_FULFILLED`: {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case `DELETE_CATEGORY_SETTINGS_REJECTED`: {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    case `DELETE_SUPER_CATEGORY_SETTINGS_PENDING`: {
      return { ...state, deleted: false, deleting: true };
    }
    case `DELETE_SUPER_CATEGORY_SETTINGS_FULFILLED`: {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case `DELETE_SUPER_CATEGORY_SETTINGS_REJECTED`: {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    case `DELETE_ANALYSIS_PLAN_SETTINGS_PENDING`: {
      return { ...state, deleted: false, deleting: true };
    }
    case `DELETE_ANALYSIS_PLAN_SETTINGS_FULFILLED`: {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case `DELETE_ANALYSIS_PLAN_SETTINGS_REJECTED`: {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    case `DELETE_VALUATION_SETTINGS_PENDING`: {
      return { ...state, deleted: false, deleting: true };
    }
    case `DELETE_VALUATION_SETTINGS_FULFILLED`: {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case `DELETE_VALUATION_SETTINGS_REJECTED`: {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/category.js